'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import SeoHead, {
  DEFAULT_META_DESCRIPTION,
  DEFAULT_META_TITLE,
} from '../../components/common/SeoHead';

const PackagesPage = () => {
  const router = useRouter();

  // Redirect to chat screen on mount
  useEffect(() => {
    router.replace('/chat');
  }, [router]);

  return (
    <SeoHead
      title={DEFAULT_META_TITLE}
      description={DEFAULT_META_DESCRIPTION}
      path='/packages'
      disableTitleSuffix
    />
  );
};

export default PackagesPage;
